import { render, staticRenderFns } from "./MessageEditorCarousel.vue?vue&type=template&id=08046976&scoped=true&"
import script from "./MessageEditorCarousel.vue?vue&type=script&lang=js&"
export * from "./MessageEditorCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorCarousel.vue?vue&type=style&index=0&id=08046976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08046976",
  null
  
)

export default component.exports